module.exports = "/_next/static/images/viva_leisure-b99f779c436a2fe95423c9f7e52e357a.png";